import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppConfigurationService } from 'src/app/core/services/configuration/app-configuration.service';
import { CampusResource } from '../../models/api/campus-resource.model';
import { Campus } from '../../models/api/campus.model';
import { WebResource } from '../../models/api/web-resource.model';
import { CampusService } from './campus.service';

@Injectable({
    providedIn: 'root'
})
export class WebResourceService {

    private campus : Campus;
    private apiURL : string;

    private webResourceActiveData  = new Subject<WebResource>();
    public  webResourceActiveData$ = this.webResourceActiveData.asObservable();

    constructor(private http: HttpClient, private appConfigurationService: AppConfigurationService, private campusService: CampusService) { 

        this.apiURL = this.appConfigurationService.baseApi + '/webresource';        
        this.campus = this.campusService.campusActive;

    }

    getWebResource(editionId: number, webResourceId: string): any {

        const url = this.apiURL + '/' + this.campus.campusId + '/' + editionId + '/' + webResourceId;
        return this.http.get<WebResource>(url).pipe(
            map((data) => {
                data = this.replaceWebResources(data);
                this.webResourceActiveData.next(data);
            })
        );
        
    }

    replaceWebResources(webResource: WebResource) : WebResource {

        webResource.title ? webResource.title = this.replaceTextWithResources(this.campus.resources, webResource.title) : null;
        webResource.sections.forEach(section => {

            section.title ? section.title = this.replaceTextWithResources(this.campus.resources, section.title) : null;

                section.items.forEach(item => {

                    item.title       ? item.title       = this.replaceTextWithResources(this.campus.resources, item.title)       : null;
                    item.text        ? item.text        = this.replaceTextWithResources(this.campus.resources, item.text)        : null;
                    item.button.text ? item.button.text = this.replaceTextWithResources(this.campus.resources, item.button.text) : null;

                });

        });

        return webResource;

    }

    replaceTextWithResources(campusResources: CampusResource[], textToReplace: string) : string {

        return textToReplace.
            replace(/#campus-year#/gi, campusResources.find(r => r.resourceId == 'campus-year')?.value);
            
    }

}
